import { makeStyles } from '@mui/styles'
const windowHeight = window.innerHeight;

export const useStyles = makeStyles((theme) => ({//Estílos solamente del componente "LoginComponent"
  container: {
    display: 'flex !important',
    flexDirection: 'column !important',
    alignItems: 'flex-start !important',
    justifyContent: 'center !important',
    height: '100vh',
    position: 'relative',
    left: '0',
    width: '100%',
    overflow: 'hidden',
    //backgroundColor: '#C20E30',
    //outline: 'solid 1px tomato !important',
  },
  canvasContainer: {
    display: 'flex !important',
    flexDirection: 'column !important',
    alignItems: 'flex-start !important',
    justifyContent: 'center !important',
    height: '35vh',
    // width: '100%',
    overflow: 'hidden',
    ['@media only screen and (max-width: 812px)']: {
      height: '40vh',
    },
    //outline: 'solid 1px tomato !important',
  },
  firmaAqui: {
    position: 'absolute',
    top: '35%',
    left: '45%',
    ['@media only screen and (max-width: 812px)']: {
      top: '45%',
      left: '38%',
    },
  },
  borradorFirma: {
    position: 'absolute',
    bottom: '0vh',
    right: '20%',
    ['@media only screen and (max-width: 812px)']: {
      position: 'absolute',
      bottom: '10vh',
      right: '20%',
    },
  },
  lineaFirma: {
    position: 'absolute',
    bottom: '25vh',
    left: '15%',
    width: '96%',
    ['@media only screen and (max-width: 812px)']: {
      position: 'absolute',
      bottom: '20vh',
      left: '15%',
      width: '96%',
    },
  },
  stageTitle: {
    // fontSize: '24px !important',
    fontWeight: '600 !important'
  },
  // stageSubtitle: {
  //   fontSize: 16,
  // },
  listView: {
    // overflow: 'auto !important',
    alignSelf: 'center',
    width: '100%',
    // height: '85%',
    // marginBottom: '1em !important',
    //outline: 'solid 1px tomato !important',
    //marginTop: 'auto',
  },

  pdfContainer: {
    alignSelf: 'center',
    width: '100%',
    height: '54vh',
    // backgroundColor: 'gray',
    border: '1px solid gray',
    ['@media only screen and (max-width: 812px)']: {
      overflow: 'auto',
      height: '48vh',
    },
  },
  pdfContainerloading: {
    marginTop: theme.spacing(2),
    width: '100%',
    height: '55vh',
    backgroundColor: 'gray',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    ['@media only screen and (max-width: 650px)']: {
      overflow: 'auto',
    },
  },
  doumentConfig: {
    display: 'flex !important',
    flexDirection: 'column !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    padding: theme.spacing(1)
  },
  continueBtn: {
    alignSelf: 'center',
  },
  signBtn: {
    display: 'flex !important',
    flexDirection: 'column !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    alignSelf: 'center',
    width: '100%',
    height: '10%',
    bottom: '0em !important',
    backgroundColor: '#C20E30',
    color: '#ffffff',
    textTransform: 'none',
    zIndex: 0,
    position: 'absolute',
    borderTopLeftRadius: theme.spacing(1),
    borderTopRightRadius: theme.spacing(1)
  },
  btnGrp: {
    width: '100% !important',
    backgroundColor: '#C20E30',
    borderTopRightRadius: theme.spacing(1),
    borderTopLeftRadius: theme.spacing(1),
    display: 'flex',
    flexDirection: 'row !important',
    justifyContent: 'space-between !important',
  },
  groupButtons: {
    padding: '3% !important',
  },
  concave: {
    marginTop: '50px',
    alignItems: 'center',
    boxShadow: '12px 12px 16px 0 rgba(0, 0, 0, 0.2), -8px -8px 12px 0 rgba(255, 255, 255, 0.25)',
    borderRadius: '15px',
    display: 'flex',
    height: '150px',
    justifyContent: 'center',
    width: '400px',
    transition: '0.6s',
    //background: 'linear-gradient(135deg, rgba(0,0,0,0.22), rgba(255,255,255,0.25))',//Concavo
    background: 'linear-gradient(-45deg, rgba(0,0,0,0.2), rgba(255,255,255,0.3))',//Convexo
    /*'&:hover': {
      alignItems: 'center',
      background: 'linear-gradient(-45deg, rgba(0, 0, 0, 0.22), rgba(255, 255, 255, 0.25))',
      boxShadow: '14px 14px 18px 0 rgba(0, 0, 0, 0.2), -10px -10px 14px 0 rgba(255, 255, 255, 0.25)',
      borderRadius: '15px',
      display: 'flex',
      height: '155px',
      justifyContent: 'center',
      width: '155px',
      background: 'linear-gradient(-45deg, rgba(0,0,0,0.2), rgba(255,255,255,0.3))',
    },
    '&:active': {
      alignItems: 'center',
      background: 'linear-gradient(-45deg, rgba(0, 0, 0, 0.22), rgba(255, 255, 255, 0.25))',
      boxShadow: '14px 14px 18px 0 rgba(0, 0, 0, 0.2), -10px -10px 14px 0 rgba(255, 255, 255, 0.25)',
      borderRadius: '15px',
      display: 'flex',
      height: '155px',
      justifyContent: 'center', 
      width: '155px',
      background: 'linear-gradient(135deg, rgba(0,0,0,0.22), rgba(255,255,255,0.25))',
    },*/
  },

  redSquare: {
    display: 'flex !important',
    flexDirection: 'column !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    backgroundColor: theme.palette.primary.light,
    borderRadius: '4px',
    height: '40px',
    width: '40px',
    marginBottom: '10px',
  },
  listElementStyle: {
    display: 'flex !important',
    flexDirection: 'row !important',
    alignItems: 'flex-start !important',
    justifyContent: 'flex-start !important',
    marginTop: theme.spacing(2),
    borderBottom: '1px solid #DFDFDF',
    width: '100%'
  },
  arrowIcon: {
    height: '15px',
    width: '10px'
  },
  signatureLine: {
    // width: '100%',
    width: '90%',
    height: '1px',
    backgroundColor: theme.palette.primary.main,
    // position: 'absolute',
    // alignSelf: 'center !important',
    // marginBottom: '70vh !important',
    // marginTop: 'auto',
    // ['@media only screen and (max-width: 712px)']: {
    //   marginBottom: '-40vh !important',
    //   marginTop: '7em',
    //   width: '90%',
    // },
  },
  signPlaceholder: {
    color: theme.palette.primary.main,
    alignSelf: 'center',
    // marginTop: '6em',
    // position: 'absolute',
    textSize: '24px',
    // ['@media only screen and (max-width: 712px)']: {
    //   marginBottom: '4em',
    // },
  },
  clearIcon: {
    color: 'black'
  },
  clearIconActive: {
    color: 'red'
  },


  // This location was when the pin was inside the pdf but they ask me to change it
  // in the jsx it was inside pdfContainer but I pull it out 
  // locationIcon: {
  //   width: '40px !important',
  //   height: '40px !important',
  //   position: 'absolute !important',
  //   right: '60px !important',
  //   marginTop: '5px !important',
  //   zIndex: '1',
  //   backgroundColor: theme.palette.primary.main,
  //   borderRadius: '30px',
  //   textAlign: 'center',
  //   ['@media only screen and (max-width: 600px)']: {
  //     right: '10px !important',
  //   },
  // },
  iconposition: {
    width: '100% !important',
    display: 'flex',
    justifyContent: 'flex-end'
  },

  locationIcon: {
    width: '40px !important',
    height: '40px !important',
    backgroundColor: theme.palette.primary.main,
    borderRadius: '100%',
    textAlign: 'center',
    marginBottom: '5px !important',
    marginRight: theme.spacing(1)
  },
  iconLoc: {
    color: '#FFFFFF',
    marginTop: '10px',
    height: '20px',
    width: '20px'
  },
  acceptBtn: {
    //margin: theme.spacing(1),
    width: '100%',
    marginTop: '10px',
  },
  controlLabel: {
    // marginTop: theme.spacing(2),
    // ".MuiFormControlLabel-root":{
    //   margin: '0px !important'
    // }
  },
  mapTitle: {
    fontWeight: 'bold',
    fontSize: 20,
    width: '90% !important',
    textAlign: 'left !important',
    ['@media only screen and (max-width: 600px)']: {
      fontSize: 18,
      marginTop: '5%'
    },
    //outline: 'solid 1px tomato !important',
  },
  mapContainer: {
    height: '70vh !important',
    width: '100% !important',
    backgroundColor: '#8F918F',
  },
  imgSign: {
    width: '100%',
    height: `${windowHeight > 900 ? 43 : 30}vh !important`,
    objectFit: 'contain',
    padding: '20px'
    //outline: 'solid 1px tomato !important',
  },
  helpButtons: {
    marginTop: '10px',
  },
  listText: {
    ['@media only screen and (max-width: 800px)']: {
      marginLeft: '-4% !important'
    },
    marginLeft: '-2% !important'
  },
  topBar: {
    height: '8vh',
    // width: '60%',
    background: theme.palette.primary.main,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
    ['@media only screen and (max-width: 650px)']: {
      // width: '100%',
      // marginBottom: theme.spacing(1),
      // marginTop: '1.5em',
      // marginTop: theme.spacing(1),
      // height: '13vh',
    },
  },

  backButton: {
    '&&:focus': {
      outline: 'none'
    }
  },

  btnContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end'
  },
  containerResult: {
    display: 'grid !important',
    gridTemplateColumns: '90% 10%',
    marginTop: 5,
    marginBottom: 5,
    overflowY: 'none',
    ['@media only screen and (max-width: 812px)']: {
      gridTemplateColumns: '87% 13%',
      overflowY: 'none',
    },
  },
  leftColumnResult: {
    display: 'flex',
    flexDirection: 'column !important',
    alignItems: 'flex-start !important',
    overflowY: 'none',
    justifyContent: 'flex-start !important',
  },
  rightColumnResult: {
    display: 'flex',
    flexDirection: 'column !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    overflowY: 'none',
  },
  ButtonActive: {
    // width: '100% !important',
    justifyContent: 'center',
    // margin: theme.spacing(1),
  },
  ButtonDisabled: {
    cursor: 'not-allowed !important',
    pointerEvents: 'none !important',
    // width: '100% !important',
    justifyContent: 'center',
    // margin: theme.spacing(1),
  },

  visorContentPrinc: {
    border: '1px solid #A0A1A2',
    position: 'relative',
    overflow: 'hidden',
    textAlign: 'center',
    height: '100%',
    width: '100%',
  },
  pdfContentCenter: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '80vh',
    textAlign: 'center',
  },
  centerContentPdfMovil: { //Help
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    height: '50vh',
    position: 'relative',
    alignItems: 'center',
    ['@media only screen and (max-width: 812px)']: {
      width: '100%',
      height: '55vh',
    }
  },
  buttonWidths: {
    width: '100% !important',
    textAlign: 'center !important',
  },

}))
